import React from "react";
import { Facebook, Twitter, MessageCircle, Mail, Share2, Link2 } from "lucide-react";
import { toast } from "sonner";

export default function SocialShare({ url, title, description }) {
  const shareUrl = encodeURIComponent(url || (typeof window !== "undefined" ? window.location.href : ""));
  const shareTitle = encodeURIComponent(title || "Tour Trips India Holidays");
  const shareDescr = encodeURIComponent(description || "Crafted journeys through Incredible India");

  const links = [
    {
      name: "Facebook",
      icon: Facebook,
      href: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      color: "hover:bg-[#1877F2] hover:text-white",
    },
    {
      name: "Twitter",
      icon: Twitter,
      href: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`,
      color: "hover:bg-[#1DA1F2] hover:text-white",
    },
    {
      name: "WhatsApp",
      icon: MessageCircle,
      href: `https://api.whatsapp.com/send?text=${shareTitle}%20${shareUrl}`,
      color: "hover:bg-[#25D366] hover:text-white",
    },
    {
      name: "Email",
      icon: Mail,
      href: `mailto:?subject=${shareTitle}&body=${shareDescr}%20${shareUrl}`,
      color: "hover:bg-saffron hover:text-white",
    },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url || window.location.href);
      toast.success("Link copied to clipboard");
    } catch (_) {
      toast.error("Unable to copy");
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="social-share">
      <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-foreground/60 mr-2">
        <Share2 className="w-3.5 h-3.5" /> Share
      </span>
      {links.map((l) => (
        <a
          key={l.name}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Share on ${l.name}`}
          data-testid={`share-${l.name.toLowerCase()}`}
          className={`w-9 h-9 rounded-sm border border-cream-200 bg-white flex items-center justify-center text-foreground/60 transition-all ${l.color}`}
        >
          <l.icon className="w-4 h-4" />
        </a>
      ))}
      <button
        onClick={copyLink}
        data-testid="share-copy"
        aria-label="Copy link"
        className="w-9 h-9 rounded-sm border border-cream-200 bg-white flex items-center justify-center text-foreground/60 hover:bg-deepred hover:text-white hover:border-deepred transition-all"
      >
        <Link2 className="w-4 h-4" />
      </button>
    </div>
  );
}
